//Importación de librerias
//---------------Comun---------------
//Catalogos
import SiNo from '../../../src/components/Comunes/Catalogos/SiNo.vue'



//Creamos y asignamos los datos necesarios de comunes
const comunes = [
  { Proviene: 'Comunes', Nombre: 'SiNo', datos: SiNo }
]

//Exportamos los datos de comunes
export default comunes;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/comun.js
// module id = null
// module chunks = 